/**
 * Formatage des montants en FCFA.
 *
 * La formule vient de DESIGN-SYSTEM.md. `toLocaleString()` sans argument suit
 * la langue du navigateur : sur un poste configuré en anglais, 374000
 * s'affichait « 374,000 » — lu comme 374 par une gestionnaire francophone.
 *
 * Le franc CFA n'a pas de décimale : l'arrondi est fait ici, une fois.
 */
const FORMAT_FR = new Intl.NumberFormat('fr-FR');

/** « 1 250 000 » — le nombre seul, sans devise. */
export const formaterNombre = (valeur) =>
  FORMAT_FR.format(Math.round(Number(valeur || 0)));

/** « 1 250 000 FCFA » — la forme complète, celle des écrans. */
export const formaterFCFA = (valeur) => `${formaterNombre(valeur)} FCFA`;

export default formaterFCFA;
